export default __webpack_public_path__ + "static/media/time-line-top.a4040841.svg";